// @ts-nocheck
import Cookies from 'js-cookie';

export const dispatchEventStorage = () => {
    const signSetItem = Cookies.set
    Cookies.set = function(key, val) {
        let setEvent = new Event('setItemEvent')
        setEvent.key = key
        setEvent.newValue = val
        window.dispatchEvent(setEvent)
        signSetItem.apply(this, arguments)
    }
}
